import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonRed from "../../components/ButtonRed";
import BonusChoose from './BonusChoose';
import AppContext from '../../AppContext';

function SecondFormStep() {
  const navigate = useNavigate();
  const { setIsRegistered } = useContext(AppContext);
  const [activeChoose, setActiveChoose] = React.useState(1);

  return (
    <div id='form-step'>
      <h4>Choose your welcome bonus</h4>
      <BonusChoose
        onClick={() => setActiveChoose(1)}
        active={activeChoose === 1}
        iconSrc='/icon/casino_w_b_icon.png'
        bonusName='Casino welcome bonus'
        bonusText='100% up to $500 + $50'
      />
      <BonusChoose
        iconSrc='/icon/sport_w_b_icon.png'
        onClick={() => setActiveChoose(2)}
        active={activeChoose === 2}
        bonusName='Sports welcome bonus'
        bonusText='150% up to 100 FS'
      />
      <BonusChoose
        onClick={() => setActiveChoose(3)}
        active={activeChoose === 3}
        iconSrc='/icon/promo_code_icon.png'
        bonusName='I have a promo code'
      />
      <BonusChoose
        onClick={() => setActiveChoose(4)}
        active={activeChoose === 4}
        iconSrc='/icon/without_w_b_icon.png'
        bonusName='Continue without a bonus'
      />
      <div className='group-row'>
        <ButtonRed
          labelText='Sign Up'
          onClick={() => {
            setIsRegistered(true);
            navigate("/");
          }}
          fontSize={24}
        />
      </div>
      <div className='spacer-16'>
        <div className='group-center'>
          <span>Already have an account?</span>
          <span className='link'>Sign in</span>
        </div>
      </div>
    </div>
  );
}

export default SecondFormStep;